module.exports = __webpack_public_path__ + "img/215.66e02076.png";